import moment from 'moment'
import {
  exactEqualStringMatcher,
  stringTextMatcher,
  exactFilterToValueMatcher,
  exactUnitFilterValueMatcher,
} from '@/components/agGrid/AgGridHelperMethods'
import variables from '@/styles/_varsJs.scss'

export const TIME_TO_LIVE_MINUTE = 1000 * 60
export const debounceTime = 500
export const debounceShortTime = 250
export const NO_PARAMETER_ALERT = 'No Parameter Alert'
export const PARAMETER = 'Parameter'
export const LONG_DATE_TIME_FORMAT = 'DD MMM YYYY HH:mm:ss'
export const ASC_LONG_DATE_TIME_FORMAT = 'DD MMM YYYY | HH:mm:ss'
export const LONG_DATE_TIME = 'YYYY-MM-DDTHH:mm:ss.SSS'
export const LONG_DATE_FORMAT = 'DD MMM YYYY'
export const LONG_TIME_FORMAT = 'HH:mm:ss'
export const API_DATE_FORMAT = 'YYYY-MM-DD'
export const ALL_AIRLINES = 'All Airlines'
export const ALL_TAILS = 'All Tails'
// MxRec Statuses
export const MX_SCHEDULED_STATUS = 10 // Maintenance Scheduled
export const MX_COMPLETED_STATUS = 11 // Maintenance Complete
export const GOOGLE_ANALYTIC_ID = 'G-5M29R5JX74'

export const MX_STATUSES = [
  {
    id: 1,
    name: 'New (FMT)',
    color: variables.primaryblack,
  },
  {
    id: 2,
    name: 'Investigate (FMT)',
    color: variables.gray500,
  },
  {
    id: 3,
    name: 'Continue to Monitor (FMT)',
    color: variables.gray300,
  },
  {
    id: 4,
    name: 'No Action Required (FMT)',
    color: variables.gray200,
  },
  {
    id: 5,
    name: 'New Mx Rec', // Old submitter/Available
    color: variables.accent800,
    issueUpdaterOnly: true,
  },
  {
    id: 7,
    name: 'Investigate',
    color: variables.accent700,
  },
  {
    id: 9,
    name: 'Need Clarification',
    color: variables.accent500,
  },
  {
    id: 10,
    name: 'Maintenance Scheduled',
    color: variables.accent400,
    issueUpdaterOnly: true,
  },
  {
    id: 11,
    name: 'Maintenance Complete',
    color: variables.accent300,
  },
  {
    id: 12,
    name: 'Closed',
    color: '',
  },
  {
    id: 14,
    name: 'Part Failed Before Replacement',
    color: '',
  },
  {
    id: 15,
    name: 'No Action Required',
    color: '',
  },
  {
    id: 16,
    name: 'Reopened',
    color: variables.accent200,
  },
  {
    id: 17,
    name: 'New Event Appended',
    color: variables.accent100,
  },
  {
    id: 18,
    name: 'Ignore',
    color: variables.accent0,
  },
]

export const CONSOLIDATED_VALUES = {
  b: 'B',
  c: 'C',
  a: 'A',
}

export const STATUS_VALUES = {
  normal: 'normal',
  computed: 'computed',
  lowWarning: 'lowAlarm',
  lowCaution: 'lowWarning',
  highCaution: 'highWarning',
  highWarning: 'highAlarm',
  faultMonitor: 'faultMonitor',
  highLowWarning: 'highLowAlarm',
  highLowCaution: 'highLowWarning',
  eventWarning: 'eventAlarm',
  eventCaution: 'eventWarning',
}

export const STATUS_TITLES = {
  lowWarning: 'Low Warning',
  lowCaution: 'Low Caution',
  highCaution: 'High Caution',
  highWarning: 'High Warning',
  highLowWarning: 'High/Low Warning',
  highLowCaution: 'High/Low Caution',
  eventWarning: 'Event Warning',
  eventCaution: 'Event Caution',
}

export const FONT_SIZES = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
  xxxl: 'xxxl',
  xxxxl: 'xxxxl',
}

export const REPORT_DATA_VALUES = {
  title: 'title',
  subtitle: 'subtitle',
  subheader: 'subheader',
  multipleSubheaders: 'multipleSubheaders',
  note: 'note',
  singleValue: 'singleValue',
  columnTable: 'columnTable',
  date: 'date',
}

export const AUTOCOMPLETE_TYPES = {
  single: 'single',
  multiple: 'multiple',
  extendedMultiple: 'extendedMultiple',
}

export const FIXED_DATE_PICKER_OPTIONS = [
  {
    id: 1,
    label: 'All Dates',
    offset: null,
    endDateOffset: null,
    type: null,
    value: '0',
  },
  {
    id: 2,
    label: 'Yesterday',
    offset: -1,
    endDateOffset: -1,
    type: 'date',
    value: '1',
  },
  {
    id: 3,
    label: 'Today',
    offset: 0,
    endDateOffset: 0,
    type: 'date',
    value: '2',
  },
  {
    id: 4,
    label: 'Last 7 Days',
    offset: -7,
    endDateOffset: 0,
    type: 'range',
    value: '3',
  },
  {
    id: 5,
    label: 'Last 30 Days',
    offset: -30,
    endDateOffset: 0,
    type: 'range',
    value: '4',
  },
  {
    id: 6,
    label: 'Last 45 Days',
    offset: -45,
    endDateOffset: 0,
    type: 'range',
    value: '7',
  },
]

export const CUSTOM_DATE_PICKER_OPTIONS = [
  {
    id: 7,
    label: 'Custom Date',
    offset: 0,
    type: 'date',
    value: '5',
  },
  {
    id: 8,
    label: 'Custom Range',
    offset: 0,
    type: 'range',
    value: '6',
  },
]

export const DATE_SELECTOR_OPTIONS = {
  titles: {
    0: 'All Dates',
    1: 'Yesterday',
    2: 'Today',
    3: 'Last 7 Days',
    4: 'Last 30 Days',
    5: 'Date',
    6: 'Range',
    7: 'Last 45 Days',
  },
  startDateOffsets: {
    0: null,
    1: -1,
    2: 0,
    3: -7,
    4: -30,
    5: 'start',
    6: 'start',
    7: -45,
  },
  endDateOffsets: {
    0: null,
    1: -1,
    2: 0,
    3: 0,
    4: 0,
    5: 'start',
    6: 'end',
    7: 0,
  },
  dateFormats: {
    0: null,
    1: 'start',
    2: 'start',
    3: 'start-end',
    4: 'start-end',
    5: 'start',
    6: 'start-end',
    7: 'start-end',
  },
}

export const PLOT_UPDATE_MESSAGES = {
  updateAllPlotData: 'Update All Plot Data',
  updatePlotTitle: 'Update Plot Title',
  updatePlotData: 'Update Plot Data',
  updatePlotCaption: 'Update Plot Caption',
  updatePlotVisibility: 'Update Plot Visibility',
  updatePlotFilters: 'Update Plot Filters',
  updatePlotTabIndex: 'Update Plot Tab Index',
  updatePlotMaintenanceIssueIds: 'Update Plot Maintenance Issue Ids',
  updateChartAutoscale: 'Update Chart Autoscale',
  updateChartSeparateCharts: 'Update Chart Separate Charts',
  updateChartZoom: 'Update Chart Zoom',
  updateChartYAxisOverrides: 'Update Chart Y-Axis Overrides',
  updateDateRange: 'Update Chart Date Range',
}

export const ANALYTIC_TRENDS_RISK_SCORE_PLOT_TYPE_ID = 9151
export const FLIGHT_PARAMETER_COMPARISON_PLOT_TYPE_ID = 7455
export const ANALYTIC_COMPARISON_RISK_SCORE_PLOT_TYPE_ID = 9124
export const FLIGHT_PARAMETER_TRENDS_PLOT_TYPE_ID = 7457
export const CONDITION_MONITORING_REPORT_DATA_TRENDS_PLOT_TYPE_ID = 8932
export const REPORT_PARAMETER_TRENDS_PLOT_TYPE_ID = 8068

export const PLOT_TYPES = [
  {
    id: ANALYTIC_TRENDS_RISK_SCORE_PLOT_TYPE_ID,
    name: 'Analytic Trends',
    description: 'Plot an analytic across multiple flights.',
    enabled: true,
    order: 3,
    maxDataTabs: 10,
    tabTitleField: 'amcFeature',
    chartType: 'time',
    seriesType: 'scatter',
    axes: {
      enabled: true,
      zoom: {
        enabled: true,
        default: 5,
      },
      autoscale: {
        enabled: true,
        default: false,
      },
      overrides: {
        enabled: true,
      },
    },
    overlays: {
      enabled: true,
      options: [],
    },
    plot: {
      max: 2.2,
      min: -0.2,
      tickInterval: 0.2,
      thresholds: [
        {
          value: 1.0,
        },
      ],
    },
    fields: [
      {
        id: 'amcAnalyticModule',
        index: 0,
        visible: true,
        isDate: false,
        label: 'Analytic',
        placeholder: 'Select Analytic',
        selection: [],
        validationCount: 1,
        multiple: false,
        extraWide: true,
      },
      {
        id: 'amcFeature',
        index: 1,
        visible: true,
        isDate: false,
        label: 'Visualization',
        placeholder: 'Select Visualization',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'amcAnalyticModule',
        lookupFields: ['analyticModuleId'],
        extraWide: true,
      },
      {
        id: 'tail',
        index: 2,
        visible: true,
        isDate: false,
        label: 'Tail',
        placeholder: 'Select Tail',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'amcAnalyticModule',
        lookupFields: ['masterModelId'],
        lookupArrayFields: [['airlineIds', 'airlineId']],
        extraWide: true,
      },
      {
        id: 'dates',
        index: 3,
        visible: true,
        isDate: true,
        showFixedOptions: true,
        hideOptionsWithId: [6],
        label: 'Dates',
        maxDays: 0,
        dropDown: true,
        selection: {
          dates: {
            value: '0',
          },
        },
      },
    ],
  },
  {
    id: FLIGHT_PARAMETER_COMPARISON_PLOT_TYPE_ID,
    name: 'Flight Parameter Comparison',
    description: 'Compare flight parameter across multiple aircraft.',
    enabled: true,
    order: 2,
    maxDataTabs: 1,
    tabTitleField: 'parameter',
    chartType: 'box',
    seriesType: 'boxplot',
    axes: {
      enabled: false,
      zoom: {
        enabled: false,
      },
      autoscale: {
        enabled: false,
      },
      overrides: {
        enabled: false,
      },
    },
    overlays: {
      enabled: false,
      options: [],
    },
    fields: [
      {
        id: 'masterModel',
        index: 0,
        visible: true,
        isDate: false,
        label: 'Platform',
        placeholder: 'Select Platform',
        selection: [],
        validationCount: 1,
        multiple: false,
      },
      {
        id: 'component',
        index: 1,
        visible: true,
        isDate: false,
        label: 'Component',
        placeholder: 'Select Component',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'masterModel',
        lookupFields: ['masterModelId'],
        extraWide: true,
      },
      {
        id: 'parameter',
        index: 2,
        visible: true,
        isDate: false,
        label: 'Parameter',
        placeholder: 'Select Parameter',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'component',
        lookupFields: ['componentId'],
        extraWide: true,
      },
      {
        id: 'flightPhase',
        index: 3,
        visible: true,
        isDate: false,
        label: 'Flight Phase',
        placeholder: 'Select Flight Phase',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'masterModel',
        lookupFields: ['masterModelId'],
        sortItems: false,
      },
      {
        id: 'tail',
        index: 4,
        visible: true,
        isDate: false,
        label: 'Tail',
        placeholder: 'Select Tail',
        selection: [],
        validationCount: 0,
        multiple: true,
        parentId: 'masterModel',
        lookupFields: ['masterModelId'],
      },
      {
        id: 'dates',
        index: 5,
        visible: true,
        isDate: true,
        showFixedOptions: true,
        label: 'Dates',
        hideOptionsWithId: [1, 6],
        maxDays: 90,
        dropDown: true,
        defaultOptionId: 5,
        selection: {
          dates: {
            value: '4',
          },
        },
      },
    ],
  },
  {
    id: ANALYTIC_COMPARISON_RISK_SCORE_PLOT_TYPE_ID,
    name: 'Analytic Comparison',
    description: 'Compare an analytic across multiple aircraft.',
    enabled: true,
    order: 1,
    maxDataTabs: 1,
    tabTitleField: 'amcFeature',
    chartType: 'box',
    seriesType: 'boxplot',
    axes: {
      enabled: false,
      zoom: {
        enabled: false,
      },
      autoscale: {
        enabled: false,
      },
      overrides: {
        enabled: false,
      },
    },
    overlays: {
      enabled: false,
      options: [],
    },
    fields: [
      {
        id: 'amcAnalyticModule',
        index: 0,
        visible: true,
        isDate: false,
        label: 'Analytic',
        placeholder: 'Select Analytic',
        selection: [],
        multiple: false,
        validationCount: 1,
        extraWide: true,
      },
      {
        id: 'amcFeature',
        index: 1,
        visible: true,
        isDate: false,
        label: 'Visualization',
        placeholder: 'Select Visualization',
        selection: [],
        validationCount: 1,
        multiple: true,
        parentId: 'amcAnalyticModule',
        lookupFields: ['analyticModuleId'],
        extraWide: true,
      },
      {
        id: 'tail',
        index: 2,
        visible: true,
        isDate: false,
        label: 'Tail',
        placeholder: 'Select Tail',
        selection: [],
        validationCount: 0,
        multiple: true,
        parentId: 'amcAnalyticModule',
        lookupFields: ['masterModelId'],
        lookupArrayFields: [['airlineIds', 'airlineId']],
        extraWide: true,
      },
      {
        id: 'dates',
        index: 3,
        visible: true,
        isDate: true,
        showFixedOptions: true,
        label: 'Dates',
        hideOptionsWithId: [1, 6],
        maxDays: 90,
        dropDown: true,
        defaultOptionId: 5,
        selection: {
          dates: {
            value: '4',
          },
        },
      },
    ],
  },
  {
    id: FLIGHT_PARAMETER_TRENDS_PLOT_TYPE_ID,
    name: 'Flight Parameter Trends',
    description: 'Plot a flight parameter across multiple flights.',
    enabled: true,
    order: 4,
    maxDataTabs: 10,
    tabTitleField: 'parameter',
    chartType: 'time',
    seriesType: 'spline',
    axes: {
      enabled: true,
      zoom: {
        enabled: true,
        default: 5,
      },
      autoscale: {
        enabled: false,
      },
      overrides: {
        enabled: true,
      },
    },
    overlays: {
      enabled: true,
      options: [],
    },
    fields: [
      {
        id: 'tail',
        index: 0,
        visible: true,
        isDate: false,
        label: 'Tail',
        placeholder: 'Select Tail',
        selection: [],
        validationCount: 1,
        multiple: false,
      },
      {
        id: 'system',
        index: 1,
        visible: true,
        isDate: false,
        label: 'System',
        placeholder: 'Select System',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'tail',
        lookupFields: ['masterModelId'],
      },
      {
        id: 'component',
        index: 2,
        visible: true,
        isDate: false,
        label: 'Component',
        placeholder: 'Select Component',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'system',
        lookupFields: ['systemId'],
        extraWide: true,
      },
      {
        id: 'parameter',
        index: 3,
        visible: true,
        isDate: false,
        label: 'Parameter',
        placeholder: 'Select Parameter',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'component',
        lookupFields: ['componentId'],
        customParameterParentId: 'tail',
        customParameterLookupFields: ['airlineId'],
        extraWide: true,
        hasDerivedParams: true,
      },
      {
        id: 'flightPhase',
        index: 4,
        visible: true,
        isDate: false,
        label: 'Flight Phase',
        placeholder: 'Select Flight Phase',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'tail',
        lookupFields: ['masterModelId'],
        sortItems: false,
      },
      {
        id: 'chartDate',
        index: 5,
        visible: true,
        isDate: true,
        showFixedOptions: false,
        label: 'Latest Departure Date',
        hideOptionsWithId: [1, 7],
        defaultOptionId: 4,
        selection: {
          dates: {
            value: '3',
          },
        },
      },
      {
        id: 'flight',
        index: 6,
        visible: true,
        isDate: false,
        label: 'Flights',
        placeholder: 'Select Flight',
        selection: [],
        validationCount: 1,
        multiple: false,
        sortItems: false,
      },
    ],
  },
  {
    id: CONDITION_MONITORING_REPORT_DATA_TRENDS_PLOT_TYPE_ID,
    name: 'Condition Monitoring Report Data Trends',
    description:
      'Compare parameters from ACMF/ACMS reports from most recent flights.',
    order: 5,
    enabled: true,
    maxDataTabs: 10,
    tabTitleField: 'acmfParameterName',
    chartType: 'time',
    seriesType: 'scatter',
    axes: {
      enabled: true,
      zoom: {
        enabled: true,
        default: 5,
      },
      autoscale: {
        enabled: false,
      },
      overrides: {
        enabled: true,
      },
    },
    overlays: {
      enabled: true,
      options: [],
    },
    fields: [
      {
        id: 'acmfAirline',
        index: 0,
        visible: true,
        isDate: false,
        label: 'Airline',
        placeholder: 'Select Airline',
        selection: [],
        validationCount: 1,
        multiple: false,
      },
      {
        id: 'acmfMasterModel',
        index: 1,
        visible: true,
        isDate: false,
        label: 'Platform',
        placeholder: 'Select Platform',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfAirline',
        lookupFields: ['airlineId'],
      },
      {
        id: 'acmfTail',
        index: 2,
        visible: true,
        isDate: false,
        label: 'Tail',
        placeholder: 'Select Tail',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfMasterModel',
        lookupFields: ['airlineId', 'masterModelId'],
      },
      {
        id: 'acmfReportType',
        index: 4,
        visible: true,
        isDate: false,
        label: 'Report Type',
        placeholder: 'Select Report Type',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfMasterModel',
        lookupFields: ['masterModelId'],
        extraWide: true,
      },
      {
        id: 'acmfParameterName',
        index: 5,
        visible: true,
        isDate: false,
        label: 'Parameter Name',
        placeholder: 'Select Parameter Name',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfReportType',
        lookupFields: ['reportNumber'],
        extraWide: true,
      },
      {
        id: 'dates',
        index: 5,
        visible: true,
        isDate: true,
        showFixedOptions: true,
        label: 'Dates',
        hideOptionsWithId: [1, 6],
        maxDays: 0,
        dropDown: true,
        defaultOptionId: 5,
        selection: {
          dates: {
            value: '4',
          },
        },
      },
    ],
  },
  {
    id: REPORT_PARAMETER_TRENDS_PLOT_TYPE_ID,
    name: 'Report Parameter Trends',
    description: '',
    order: 6,
    enabled: false,
    maxDataTabs: 10,
    tabTitleField: 'acmfParameterName',
    chartType: 'time',
    seriesType: 'scatter',
    axes: {
      enabled: true,
      zoom: {
        enabled: true,
        default: 5,
      },
      autoscale: {
        enabled: true,
        default: true,
      },
      overrides: {
        enabled: true,
      },
    },
    overlays: {
      enabled: false,
      options: [],
    },
    fields: [
      {
        id: 'acmfAirline',
        index: 0,
        visible: true,
        isDate: false,
        label: 'Airline',
        placeholder: 'Select Airline',
        selection: [],
        validationCount: 1,
        multiple: false,
        extraWide: false,
      },
      {
        id: 'acmfMasterModel',
        index: 1,
        visible: true,
        isDate: false,
        label: 'Platform',
        placeholder: 'Select Platform',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfAirline',
        lookupFields: ['airlineId'],
        extraWide: false,
      },
      {
        id: 'acmfTail',
        index: 2,
        visible: true,
        isDate: false,
        label: 'Tail',
        placeholder: 'Select Tail',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfMasterModel',
        lookupFields: ['airlineId', 'masterModelId'],
        extraWide: false,
      },
      {
        id: 'acmfReportType',
        index: 4,
        visible: true,
        isDate: false,
        label: 'Report Type',
        placeholder: 'Select Report Type',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfMasterModel',
        lookupFields: ['masterModelId'],
        extraWide: true,
      },
      {
        id: 'acmfParameterName',
        index: 5,
        visible: true,
        isDate: false,
        label: 'Parameter Name',
        placeholder: 'Select Parameter Name',
        selection: [],
        validationCount: 1,
        multiple: false,
        parentId: 'acmfReportType',
        lookupFields: ['reportNumber'],
        extraWide: true,
      },
    ],
  },
]

// These constant values must reflect what is in CustomAlertType Table in SQL DB
export const ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID = 5
export const ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID = 4
export const ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID = 3
export const CUSTOM_ALERT_FULL_FLIGHT_DATA_ID = 2
export const CUSTOM_ALERT_SNAPSHOT_DATA_ID = 1
export const CUSTOM_ALERT_SOURCE_ID = 8
export const CHRONIC_REPEATERS_SOURCE_ID = 9
export const REPEATER_MANUAL = 10

export const CUSTOM_ALERTS = [
  {
    id: CUSTOM_ALERT_FULL_FLIGHT_DATA_ID,
    name: 'Full Flight Data',
    description:
      'Configure parameter alerting thresholds on full flight sensor data',
  },
  {
    id: CUSTOM_ALERT_SNAPSHOT_DATA_ID,
    name: 'ACMF Data',
    description:
      'Configure parameter alerting thresholds based on sensor data collected through ACMF reports',
  },
]

export const ADVANCED_CUSTOM_ALERTS = [
  {
    id: ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID,
    name: 'Full Flight Data',
  },
  {
    id: ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID,
    name: 'ACMF Data',
  },
  {
    id: ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID,
    name: 'Fault Code Data',
  },
]

export const ADVANCED_ACMF_CONFIGURATION_OPTIONS = [
  {
    label: 'Flights',
    value: 'persistence',
  },
  {
    label: 'Days',
    value: 'aggregateDays',
  },
  {
    label: 'Reports',
    value: 'aggregateReports',
  },
]

export const CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT = 1000

export const ADVANCED_ACMF_AGGREGATE_DAYS_MIN = 1
export const ADVANCED_ACMF_AGGREGATE_DAYS_MAX = 30
export const ADVANCED_ACMF_AGGREGATE_REPORTS_MIN = 1
export const ADVANCED_ACMF_AGGREGATE_REPORTS_MAX = 60

export const CUSTOM_ALERT_PARAMETER_SNAPSHOT_COLUMN_DEFS = [
  {
    headerName: '',
    field: '',
    width: 42,
    maxWidth: 42,
    resizable: false,
    checkboxSelection: true,
    suppressMovable: true,
    suppressSizeToFit: true,
  },
  {
    field: 'parameter',
    width: 375,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'rawName',
    width: 113,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'reportType',
    width: 135,
  },
  {
    field: 'system',
    filter: 'agTextColumnFilter',
    width: 101,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    field: 'airline',
    width: 88,
  },
  {
    field: 'platform',
    filter: 'agTextColumnFilter',
    width: 83,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    headerName: 'unit',
    field: 'unit',
    filter: 'agTextColumnFilter',
    width: 133,
    filterParams: {
      textMatcher: exactUnitFilterValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
]

export const CUSTOM_ALERT_PARAMETER_FULLFLIGHT_COLUMN_DEFS = [
  {
    headerName: '',
    field: '',
    width: 42,
    maxWidth: 42,
    resizable: false,
    checkboxSelection: true,
    suppressMovable: true,
    suppressSizeToFit: true,
  },
  {
    field: 'parameter',
    width: 341,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'rawName',
    width: 146,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'system',
    filter: 'agTextColumnFilter',
    width: 100,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    field: 'airline',
    width: 86,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    field: 'platform',
    filter: 'agTextColumnFilter',
    width: 83,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    headerName: 'unit',
    field: 'unit',
    filter: 'agTextColumnFilter',
    width: 113,
    filterParams: {
      textMatcher: stringTextMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
]

// prettier-ignore
export const EVENT_REPORT_FILTER_FIELDS = [
  {
    id: 'acmfEventReportDate',
    index: 0,
    visible: true,
    isDate: true,
    showFixedOptions: true,
    label: 'Report Date',    
    hideOptionsWithId: [1, 6],
    maxDays: 30,
    dropDown: true,
    defaultOptionId: 4,
    selection: {
      dates: {
        value: '3',
      },
    },
  },
]

export const REPORT_FILTER_FIELDS = [
  {
    id: 'acmfAirline',
    index: 0,
    visible: true,
    isDate: false,
    label: 'Airline',
    placeholder: 'Select Airline',
    selection: [],
    validationCount: 1,
    multiple: false,
  },
  {
    id: 'acmfMasterModel',
    index: 1,
    visible: true,
    isDate: false,
    label: 'Platform',
    placeholder: 'Select Platform',
    selection: [],
    validationCount: 1,
    multiple: true,
    parentId: 'acmfAirline',
    lookupFields: ['airlineId'],
  },
  {
    id: 'acmfReportDate',
    index: 5,
    visible: true,
    isDate: true,
    showFixedOptions: true,
    label: 'Report Date',
    hideOptionsWithId: [1, 6],
    maxDays: 30,
    dropDown: true,
    defaultOptionId: 4,
    selection: {
      dates: {
        value: '3',
      },
    },
  },
]

export const REMOVALS_FILTER_FIELDS = [
  {
    id: 'tail',
    index: 0,
    visible: true,
    isDate: false,
    label: 'Tail',
    placeholder: 'Select Tail',
    selection: [],
    validationCount: 1,
    multiple: false,
  },
  {
    id: 'dates',
    index: 1,
    visible: true,
    isDate: true,
    showFixedOptions: true,
    label: 'Dates',
    hideOptionsWithId: [1, 6],
    maxDays: 180,
    dropDown: true,
    defaultOptionId: 8,
    selection: {
      dates: {
        startDate: moment(new Date(moment().subtract(2, 'weeks'))).format(
          'YYYY-MM-DD',
        ),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
        value: '6',
      },
    },
  },
]

export const HIGHCHART_COLORS = [
  '#479D9A',
  '#3729FF',
  '#f7a35c',
  '#8085e9',
  '#f15c80',
  '#e4d354',
  '#434348',
  '#f45b5b',
  '#7cb5ec',
  '#90ed7d',
]

export const HIGHCHART_ICONS = [
  'circle',
  'diamond',
  'square',
  'triangle',
  'triangle-down',
]

// prettier-ignore
export const OVERLAYS = [
  {
    id: 1,
    name: 'PHM Alerts',
  },
  {
    id: 2,
    name: 'Mx Recs',
  },
  {
    id: 3,
    name: 'Mx Actions',
  },
  {
    id: 4,
    name: 'FDEs',
  },
  {
    id: 5,
    name: 'NCMMs',
  },
  {
    id: 6,
    name: 'MMOs',
  },
  {
    id: 7,
    name: 'Removals',
  },
  {
    id:8,
    name:'MMS'
  }
]

export const CODE_FLIGHT_PHASES = {
  PO: 'Power On',
  ES: 'Engine Start',
  TA: 'Taxi Out',
  TO: 'Take Off',
  IC: 'Initial Climb',
  CL: 'Climb',
  ER: 'Cruise',
  DC: 'Descent',
  AP: 'Approach',
  GA: 'Go Around',
  FL: 'Flare',
  RO: 'Rollout',
  TI: 'Taxi In',
  SD: 'Shut Down',
}

export const CODE_STATES = {
  A: 'Active',
  I: 'Inactive',
  L: 'Latched',
}

export const CODE_PERSISTENCES = {
  H: 'H',
  I: 'I',
  M: 'M',
}

export const FLIGHTS = [
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' },
  { id: 5, name: '5' },
  { id: 6, name: '6' },
  { id: 7, name: '7' },
  { id: 8, name: '8' },
  { id: 9, name: '9' },
  { id: 10, name: '10' },
]

export const DAYS_BACK = [
  { id: 7, name: 'Last 7 Days' },
  { id: 15, name: 'Last 15 Days' },
  { id: 30, name: 'Last 30 Days' },
  { id: 45, name: 'Last 45 Days' },
  { id: 60, name: 'Last 60 Days' },
  { id: 90, name: 'Last 90 Days' },
]

export const groupSortOrders = [
  'Custom',
  'Filtered',
  'preSubmittal',
  'airline',
  'closed',
  'Systems',
  'Components',
  'Parameters',
]

// Airline Agreement Type Id's
export const PWC_PHM_TIER_0 = 2 // Pratt & Whitney Canada PHM Agreement - Tier 0
export const HEALTH_MONITORING_TIER_1 = 3
export const FULL_FLIGHT_TIER_2 = 4
export const COLLINS_PHM_TIER_3 = 5
export const COLLINS_PHM_TIER_4 = 1 // Collins PHM Agreement plus Fleet Monitoring - Tier 4
export const REPEATERS = 6
export const MINUTES_BEFORE_POWER_BI_TOKEN_EXPIRATION = 10
export const POWER_BI_TOKEN_REFRESH_INTERVAL_TIME = 300000

export const MAINTENANCE_GRID_SORT_COLUMNS = {
  'New (FMT)': 1,
  'Investigate (FMT)': 2,
  'Continue to Monitor (FMT)': 3,
  'No Action Required (FMT)': 4,
  'New Mx Rec': 5,
  Investigate: 7,
  'Need Clarification': 9,
  'Maintenance Scheduled': 10,
  'Maintenance Complete': 11,
  Closed: 12,
  'Part Failed Before Replacement': 14,
  'No Action Required': 15,
}

export const ZOOM_CHIPS = [
  {
    text: '1m',
    value: 0,
  },
  {
    text: '3m',
    value: 1,
  },
  {
    text: '6m',
    value: 2,
  },
  {
    text: '1y',
    value: 3,
  },
  {
    text: 'YTD',
    value: 4,
  },
  {
    text: 'All',
    value: 5,
    activeChip: true,
  },
]

export const AIRLINE_TEXT_FIELD = 'name'

export const COUNTRIES = [
  'Unknown',
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antigua & Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia & Herzegovina',
  'Botswana',
  'Brazil',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Canada',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  'Cote D Ivoire',
  'Croatia',
  'Cruise Ship',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Polynesia',
  'French West Indies',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kuwait',
  'Kyrgyz Republic',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macau',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Namibia',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Pierre & Miquelon',
  'Samoa',
  'San Marino',
  'Satellite',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sri Lanka',
  'St Kitts & Nevis',
  'St Lucia',
  'St Vincent',
  'St. Lucia',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  "Timor L'Este",
  'Togo',
  'Tonga',
  'Trinidad & Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks & Caicos',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Venezuela',
  'Vietnam',
  'Virgin Islands (US)',
  'Yemen',
  'Zambia',
  'Zimbabwe',
]

export const DEFAULT_ECCN_TEXT =
  'Proprietary Information. Licensable technical data strictly prohibited.'

export const PERMISSION_LEVEL_CONSTS = {
  NAMESPACE: 'permissionsLevel',
  READ: 1,
  EDIT: 2,
  DELETE: 4,
}

export const RESOURCES = {
  MAINTENANCE_REC: 'Maintenance_Rec',
  MANUAL_MAINTENANCE_REC: 'Manual_Maintenance_Rec',
  MAINTENANCE_REC_INVESTIGATION: 'Maintenance_Rec_Investigation',
  ISSUE_INVESTIGATION_STATUSES: 'Issue_Investigation_Statuses',
  PRIVATE_FEATURES: 'Private_Features',
  FEATURE_INVESTIGATION: 'Feature_Investigation',
  NON_APU_DATA: 'NON_APU_DATA',
  AOG_ISSUE: 'AOG_Issue',
  AOG_SERVICE_STATUS: 'AOG_Service_Status',
  FAULT_CODE_ADMIN: 'Fault_Code_Admin',
  MANUAL_REPEATER_MAINTENANCE_REC: 'Manual_Repeater_Maintenance_Rec',
  REPEATER_ISSUE: 'Repeater_Issue',
  AOG_FLEET_MANAGEMENT: 'AOG_Fleet_Management',
  FLEET_MONITORING: 'Fleet_Monitoring',
  FAULT_SUMMARY: 'Fault_Summary',
  AIRLINE_ADMIN: 'Airline_Admin',
  USER_TAGGING: 'User_Tagging',
}

export const ELLIPSES_OPTION = [
  {
    listIcon: 'mdi-open-in-new',
    title: 'View',
    styleClass: 'view',
    ownerOnly: false,
    isCollinsAscentia: true,
    isCommon: true,
    disabled: false,
    toolTipText:
      'Only the person who created this dashboard can edit, manage permissions, and delete it. You can use the Duplicate function to access creator capabilities.',
  },
  {
    listIcon: 'mdi-plus-circle-multiple-outline',
    title: 'Duplicate to My Airline Workspace',
    styleClass: 'duplicate',
    ownerOnly: false,
    isCollinsAscentia: true,
    isCommon: false,
    disabled: false,
    toolTipText:
      'Only the person who created this dashboard can edit, manage permissions, and delete it. You can use the Duplicate function to access creator capabilities.',
  },
  {
    listIcon: 'mdi-plus-circle-multiple-outline',
    title: 'Duplicate',
    styleClass: 'duplicate',
    ownerOnly: false,
    isCollinsAscentia: false,
    isCommon: false,
    disabled: false,
    toolTipText:
      'Only the person who created this dashboard can edit, manage permissions, and delete it. You can use the Duplicate function to access creator capabilities.',
  },
  {
    listIcon: 'mdi-pencil',
    title: 'Edit',
    styleClass: 'edit',
    ownerOnly: true,
    isCollinsAscentia: false,
    isCommon: false,
    disabled: false,
    toolTipText:
      'Only the person who created this dashboard can edit, manage permissions, and delete it. You can use the Duplicate function to access creator capabilities.',
  },
  {
    listIcon: 'mdi-account-multiple',
    title: 'Manage Permissions',
    styleClass: 'manage-permission',
    ownerOnly: true,
    isCollinsAscentia: false,
    isCommon: false,
    disabled: false,
    toolTipText:
      'Only the person who created this dashboard can edit, manage permissions, and delete it. You can use the Duplicate function to access creator capabilities.',
  },
  {
    listIcon: 'mdi-delete',
    title: 'Delete',
    styleClass: 'delete',
    ownerOnly: true,
    isCollinsAscentia: false,
    isCommon: false,
    disabled: false,
    toolTipText:
      'Only the person who created this dashboard can edit, manage permissions, and delete it. You can use the Duplicate function to access creator capabilities.',
  },
]

export const ROLE_CONSTS = {
  admin: {
    name: 'Admin',
  },
  airlineAdmin: {
    name: 'AirlineAdmin',
  },
  airlineUser: {
    name: 'AirlineUser',
  },
  engineer: {
    name: 'Engineer',
  },
  userManager: {
    name: 'UserManager',
  },
  tester: {
    name: 'Tester',
  },
  acmfUser: {
    name: 'AcmfUser',
  },
  exporter: {
    name: 'Exporter',
  },
  pwcUser: {
    name: 'PwcUser',
  },
  acmfAnalyticsAuthorized: {
    name: 'AcmfAnalyticsAuthorized',
  },
  analyticAdmin: {
    name: 'AnalyticAdmin',
  },
  documentManager: {
    name: 'DocumentManager',
  },
  issueInvestigator: {
    name: 'IssueInvestigator',
  },
  featureInvestigator: {
    name: 'FeatureInvestigator',
  },
  issueUpdater: {
    name: 'IssueUpdater',
  },
  issueReader: {
    name: 'IssueInvestigationReader',
  },
  airlineManager: {
    name: 'AirlineManager',
  },
  userReader: {
    name: 'UserReader',
  },
  anserUser: {
    name: 'AnserUser',
  },
}

export const PERMISSION_CONSTS = {
  homepage: {
    name: 'Homepage',
  },
  fleetPageOpenMaintenance: {
    name: 'Fleet Page - Open Maintenance',
  },
  fleetPageMyFleet: {
    name: 'Fleet Page - My Fleet',
  },
  fleetPageFaultMessage: {
    name: 'Fleet Page - Fault Message',
  },
  fleetPageHealthScore: {
    name: 'Fleet Page - Health Score',
  },
  flightDataAnalyticComparison: {
    name: 'Flight Data - Analytic Comparison',
  },
  flightDataFlightComparison: {
    name: 'Flight Data - Flight Comparison',
  },
  flightDataAnalyticTrends: {
    name: 'Flight Data - Analytic Trends',
  },
  flightDataFlightTrends: {
    name: 'Flight Data - Flight Trends',
  },
  flightDataAcmfTrends: {
    name: 'Flight Data - ACMF Trends',
  },
  flightDataAttachPlotToMxRec: {
    name: 'Flight Data - Attach Plot to MX Rec',
  },
  flightDataSavedPlots: {
    name: 'Flight Data - Saved Plots',
  },
  maintenanceGrid: {
    name: 'Maintenance - Grid',
  },
  maintenanceExportTableGrid: {
    name: 'Maintenance - Export Table Grid',
  },
  maintenanceExportTableDetailed: {
    name: 'Maintenance - Export Table Detailed',
  },
  maintenanceManualMxRec: {
    name: 'Maintenance - Manual Mx Rec',
  },
  maintenanceRemovalsTimeline: {
    name: 'Maintenance - Removals Timeline',
  },
  reportsReportsApu: {
    name: 'Reports - Reports APU',
  },
  reportsExport: {
    name: 'Reports - Export',
  },
  subscriptionAcmfAnalytics: {
    name: 'Subscription - ACMF Analytics',
  },
  subscriptionAcmfReports: {
    name: 'Subscription - ACMF Reports',
  },
  subscriptionMaintenance: {
    name: 'Subscription - Maintenance',
  },
  customAlertsFullFlightSimple: {
    name: 'Custom Alerts - Full Flight Simple',
  },
  customAlertsFullFlightAdvanced: {
    name: 'Custom Alerts - Full Flight Advanced',
  },
  customAlertsAcmfSimple: {
    name: 'Custom Alerts - ACMF Simple',
  },
  customAlertsAcmfAdvanced: {
    name: 'Custom Alerts - ACMF Advanced',
  },
  customAlertsDplfAdvanced: {
    name: 'Custom Alerts - DPLF Advanced',
  },
  derivedParametersFullFlight: {
    name: 'Derived Parameters - Full Flight',
  },
  admin: {
    name: 'Admin',
  },
  maintenanceManualRepeaterMxRec: {
    name: 'Manual_Repeater_Maintenance_Rec',
  },
}

export const ASC_HELP_CONTACT = {
  phone: '18006336882',
  formattedPhone: '1-800-633-6882', //formatted for UI display
  email: 'AOChelpdesk@collins.com',
}
